<template>
  <div
    id="dropdown-container"
    class="text-blue-gray-800 focus-within:border focus-within:border-green-600 hover:border hover:border-green-500"
  >
    <button
      type="button"
      class="relative w-full h-full pl-3 pr-7 text-left cursor-default focus:outline-hidden"
      aria-haspopup="listbox"
      aria-expanded="true"
      @click="toggleDropDown"
    >
      <span class="flex items-center">
        <span class="block truncate">{{
          Array.from(props.eventTypes)
            .filter((eventType) => eventType[1])
            .map((eventType) => eventType[0])
            .join(", ")
        }}</span>
      </span>
      <span
        class="absolute right-0 inset-y-0 pr-1 flex items-center pointer-events-none"
      >
        <SvgCircumflexCaron class="w-5 h-5" />
      </span>
    </button>
    <div
      class="absolute flex left-0 max-sm:w-screen max-sm:bottom-10 max-sm:pl-2 max-sm:pr-6 sm:top-[42px] pl-2 pr-2"
      v-if="active"
    >
      <ul
        class="z-10 left-0 max-sm:bottom-10 max-h-56 max-sm:-ml-[9px] my-1 px-1 py-3 overflow-y-auto flex flex-wrap justify-around bg-glass border border-green-600 rounded-lg shadow-lg focus:outline-hidden"
        tabindex="-1"
        role="listbox"
        aria-activedescendant="listbox-option-0"
      >
        <li
          v-for="eventType of eventTypes"
          class="relative cursor-default select-none space-y-2 focus-within:ring-1 focus-within:ring-inset focus-within:ring-green-600 focus-within:rounded-lg active:transform active:scale-95"
          :class="
            eventType[1]
              ? 'ring-1 ring-inset ring-green-600 rounded-lg bg-green-100'
              : ''
          "
          id="listbox-option-0"
          role="option"
          @click="preToggleFilterMember($event, eventType)"
        >
          <button
            class="w-full px-2 flex items-center rounded-lg focus:outline-hidden"
          >
            <span
              class="w-full py-2 text-left font-normal block truncate border-b border-green-600/20 hover:text-green-600 focus:text-green-600"
              >{{ eventType[0] }}</span
            >
          </button>
        </li>
        <li class="w-full"></li>
        <li v-for="button in buttons">
          <button
            type="button"
            class="mt-1 px-2 py-1 border border-blue-gray-300 text-blue-gray-500 bg-blue-gray-100 hover:text-green-600 hover:border hover:border-green-500 active:transform active:scale-95 rounded-md"
            aria-haspopup="listbox"
            aria-expanded="true"
            @click="button.callback"
          >
            {{ button.label }}
            <component
              v-if="button.icon"
              :is="button.icon"
              class="inline align-bottom h-6"
            ></component>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { EventTypes } from "@/types/EventFilters";
import type { EventType } from "@/types/Events";

const props = defineProps<{
  eventTypes: EventTypes;
  buttons?: Array<{
    label: string;
    icon?: Component;
    callback: (payload: MouseEvent) => void;
  }>;
}>();

const emit = defineEmits(["toggleFilterMember"]);

const active = ref(false);
const toggleDropDown = () => {
  active.value = !active.value;
  if (!active.value) {
    (event.target?.closest("div")?.firstChild as HTMLElement).focus();
  }
};

const preToggleFilterMember = async (
  event: MouseEvent,
  eventType: [EventType, boolean]
) => {
  eventType[1] = !eventType[1];
  emit("toggleFilterMember", eventType);
};

onMounted(() => {
  document.addEventListener("click", (event) => {
    if (!(event.target as HTMLElement).closest("#dropdown-container")) {
      active.value = false;
    }
  });
});
</script>
